import { $authHost } from ".."
import { getStartParamsQuery } from "../../helpers/api/apiHelper"

export const addSupplyOrderAPI = async (supplyOrder) => {
    const {data} = await $authHost.post(`api/supply_orders/`, supplyOrder)
    return data
}

export const createNewSupplyOrderFromOrderAPI = async ({ supplyOrderId, itemsChecked, userId }) => {
    const {data} = await $authHost.post(`api/supply_orders/create_new_by_order`, { supplyOrderId, itemsChecked, userId })
    return data
}

export const editSupplyOrderAPI = async (supplier) => {
    const {data} = await $authHost.post(`api/supply_orders/${supplier.id}`, supplier)
    return data
}

export const editSupplyOrderUserAPI = async ({ supplyOrderId, userId }) => {
    const {data} = await $authHost.post(`api/supply_orders/${supplyOrderId}/user`, { userId })
    return data
}

export const editSupplyOrderStatusAPI = async ({ supplyOrderId, status }) => {
    const {data} = await $authHost.post(`api/supply_orders/${supplyOrderId}/status`, { status })
    return data
}

export const getSupplyOrderAPI = async ({ supplyOrderId }) => {
    const {data} = await $authHost.get(`api/supply_orders/${supplyOrderId}`)
    return data
}

export const getSupplyOrdersAPI = async ({ offset, limit, query, status, departmentId, agreeDirector }) => {

    // let params = ''
    // if (query) {
    //     params = `?query=${query}`
    // } else if ((offset || offset === 0) && limit) {
    //     params = `?offset=${offset}&limit=${limit}`
    // }

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    if (status) {
        params += `${getStartParamsQuery({ params })}status=${status}`
    }

    if (departmentId) {
        params += `${getStartParamsQuery({ params })}departmentId=${departmentId}`
    }

    if (agreeDirector) {
        params += `${getStartParamsQuery({ params })}agreeDirector=${agreeDirector}`
    }

    const {data} = await $authHost.get(`api/supply_orders/${params}`)
    return data
}

export const agreeSupplyOrderItemsDirectorAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/supply_orders/agree_items_director/${dataForBd.id}`, dataForBd)
    return data
}
